import { useEffect, useRef, useState } from 'react'
import { message, Spin } from 'antd'
import { SGeneralForms } from 'shj-components'
import { addDispatchStore, updateDispatchStore } from '@/services/customerServices'
export default function AddOrEditForm(props: any) {
  const { editData, state, editRef, setBtnLoading, onCancel, fn } = props
  const formRef: any = useRef()
  const [spinning, setSpinning] = useState(false)
  const reqMeg = '不能为空'
  useEffect(() => {
    initFn()
  }, [])
  const initFn = async () => {
    if (editData) {
      setSpinning(true)
      formRef.current?.onFormRef()?.setFieldsValue({ ...editData })
      setSpinning(false)
    }
  }
  const getOptions = async () => {
    return Promise.resolve({
      companyList: state.companyList,
      regionList: state.regionList,
      BizOpTypeEnumList: state.BizOpTypeEnumList,
      brandList: state.brandList,
    })
  }
  const onFinish = () => {
    formRef.current
      ?.onFormRef()
      ?.validateFields()
      .then(values => {
        setBtnLoading(true)
        let apiPost
        if (editData) {
          apiPost = updateDispatchStore
        } else {
          apiPost = addDispatchStore
        }
        apiPost(values).then(() => {
          message.success('操作成功')
          onCancel()
          fn()
        })
        .finally(() => {
          setBtnLoading(false)
          onCancel()
        })
      })
  }
  if (editRef) editRef.onFinish = onFinish
  return (
    <Spin spinning={spinning}>
      <SGeneralForms
        ref={formRef}
        layout={'vertical'}
        httpOptionsFn={getOptions}
        configs={[
          {
            formItem: [
              { label: 'id', name: 'id', hidden: true },
              {
                label: '品牌',
                name: 'brandId',
                spanCol: 24,
                type: 'select',
                required: true,
                data: 'brandList',
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  fieldNames: { value: 'id', label: 'brandName' },
                },
              },
              {
                label: '需求类型',
                name: 'bizType',
                spanCol: 24,
                type: 'select',
                data: 'BizOpTypeEnumList',
                required: true,
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  fieldNames: { value: 'key', label: 'description' },
                },
              },
              {
                label: '城市',
                name: 'cityCode',
                spanCol: 24,
                type: 'select',
                data: 'regionList',
                required: true,
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  fieldNames: { value: 'regionCode', label: 'regionName' },
                },
              },
              {
                label: '门店',
                name: editData ? 'storeId' : 'storeIds',
                spanCol: 24,
                type: 'select',
                required: true,
                data: 'companyList',
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  mode: editData ? 'default' : 'multiple',
                  fieldNames: { value: 'id', label: 'name' },
                },
              },
            ],
          },
        ]}
      />
    </Spin>
  )
}
